<template>
  <div class="worth-container">
    <img src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-one.jpg" />
    <img src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-ten.jpg" />
    <img src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-three.jpg" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/sell_phone_4.jpg" />
    <img src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-button1.jpg" @click="gotoDetailPage(0)" />
    <img src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-button2.jpg" @click="gotoDetailPage(1)" />
    <img src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-seven.jpg" />

    <div class="botttom-button">
      <img class="btn" @click="gotoPage()" src="https://ysh-cdn.kaidicloud.com/test/activity/phone/sell_phone-eight.png" />
    </div>
  </div>
</template>

<script>
import { getJoinChamber, getYYWxLink } from '@/api/data'

export default {
  data() {
    return {
      token: '',
      yywxlink1: '',
      yywxlink2: '',
      yywxlink3: '',
      type: '',
      //判断是否加入江西商会
      chamberFlag: false,
      linkMap: [
        {
          zx: '/pages/goods-detail/index?goodsId=6153793064493204216',
          pt: '/pages/goods-detail/index?goodsId=5406526792947419128',
        },
        {
          zx: '/pages/goods-detail/index?goodsId=3005958528012732658',
          pt: '/pages/goods-detail/index?goodsId=256483787308680341',
        },
      ],
    }
  },
  created() {
    this.type = this.$route.query.type || ''

    let that = this

    if (this.type != 'app') {
      getYYWxLink('/subpackage_activity/pages/special-detail/index', 'topicId=100639').then((res) => {
        if (res.data.state !== 1) return
        that.yywxlink1 = res.data.data.urlscheme
      })

      getYYWxLink('/pages/goods-detail/index', 'goodsId=5406526792947419128').then((res) => {
        if (res.data.state !== 1) return
        that.yywxlink2 = res.data.data.urlscheme
      })

      getYYWxLink('/pages/goods-detail/index', 'goodsId=256483787308680341').then((res) => {
        if (res.data.state !== 1) return
        that.yywxlink3 = res.data.data.urlscheme
      })
    }

    //urlscheme
  },
  mounted() {
    window.setToken = this.setToken
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

    if (isAndroid) {
      window.YshApp.getToken()
    } else if (isiOS) {
      window.webkit.messageHandlers.getToken.postMessage('')
    }
  },

  methods: {
    setToken(loginInfo) {
      this.token = loginInfo.token
      if (this.token) {
        let that = this
        getJoinChamber(this.token, 1, 100).then((res) => {
          if (res.data.state !== 1) return
          if (res.data.data && res.data.data.joinedChamberLst && res.data.data.joinedChamberLst.length) {
            data.data.joinedChamberLst.forEach((item) => {
              if (item.name === '广东省江西商会') {
                that.chamberFlag = true
              }
            })
          }
        })
      }
    },

    gotoPage() {
      if (this.type == 'app') {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

        let path = encodeURIComponent('/subpackage_activity/pages/special-detail/index?topicId=100639')

        var nativeData = {
          code: 'wechatApp',
          query: 'path=' + path + '&miniId=wx7a8b2564db00dcb3&miniProgramType=0&miniAppId=gh_badffd18239a',
        }

        if (isAndroid) {
          window.YshApp.goToPage(JSON.stringify(nativeData))
        } else if (isiOS) {
          window.webkit.messageHandlers.goToPage.postMessage(JSON.stringify(nativeData))
        }
      } else {
        window.location.href = this.yywxlink1
      }
    },

    async gotoDetailPage(index) {
      if (this.type == 'app') {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
        let url = ''
        if (this.chamberFlag) {
          url = this.linkMap[index].zx
        } else {
          url = this.linkMap[index].pt
        }

        let path = encodeURIComponent(url)

        var nativeData = {
          code: 'wechatApp',
          query: 'path=' + path + '&miniId=wx7a8b2564db00dcb3&miniProgramType=0&miniAppId=gh_badffd18239a',
        }

        if (isAndroid) {
          window.YshApp.goToPage(JSON.stringify(nativeData))
        } else if (isiOS) {
          window.webkit.messageHandlers.goToPage.postMessage(JSON.stringify(nativeData))
        }
      } else {
        if (index) {
          window.location.href = this.yywxlink3
        } else {
          window.location.href = this.yywxlink2
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.worth-container {
  display: flex;
  flex-direction: column;
}

.worth-container img {
  width: 100vw;
  height: auto;
}

.botttom-button {
  width: 100vw;
  height: 150px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
}

.botttom-button .btn {
  position: absolute;
  left: 50%;
  top: 8px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
  animation: breath 0.6s linear 0.5s infinite alternate;
}

.botttom-button .btn-bg {
  width: 100%;
  height: 150px;
}
</style>